export const resume = {
	title: "Summary",
	pageTitle: "Promotion summary",
	description:
		"Check that all the information is correct and then publish the promotion. It will automatically activate and be ready to use.",
	sections: {
		allProducts: "All products",
		andMore: "and more {{count}} products",
		promotionInfo: {
			title: "Promotion information",
			channel: "Channel",
			audience: "Who can receive this promotion",
			audienceValues: {
				everybody: "All customers",
				identifiedCpf: "Identified customers",
			},
			cpfPermissionWarning:
				"To identify customers on the ticket kiosk, the 'capture CPF on ticket kiosk' permission must be enabled.",
			name: "Name",
			description: "Description",
			maxUses: {
				label: "Quantities of uses per gain",
				uses: "{{uses}} uses",
				withoutLimits: "No Boundaries",
			},
			places: "Locations",
		},
		goals: {
			title: "Goals",
			frequency: "Recurrence of earnings",
		},
		awards: {
			title: "Awards",
			discount: "Discount percentage applied to the product",
			products: "Discount products",
		},
		usageLimit: {
			label: "Usage limit",
			uses: "{{uses}} uses",
		},
		usageConditions: "Conditions of use",
	},
};
